export default "__VITE_ASSET__CR8fpd7C__"